// Import translation
import { useTranslation } from 'react-i18next';

// Import variables
import { LOGIN_SYSTEM_TYPES } from 'helpers/variables';

export const useLoginSettings = (loginType, provider, isError) => {
	const { t } = useTranslation();
	const hasFirebaseAuthentication = !!process.env.REACT_APP_FIREBASE_AUTH;

	const providerNameCapitalized =
		provider && formatProviderTypeString(provider);

	const providerDescription = t('common_login_form_provider_title').replace(
		':providerType',
		providerNameCapitalized
	);

	if (isError) {
		return {
			loginInfo: providerDescription,
			renderFirebaseAuth: false
		};
	}

	if (loginType === LOGIN_SYSTEM_TYPES.pureott) {
		return {
			loginInfo: `${t('common_login_form_ott_title')}`,
			renderFirebaseAuth: hasFirebaseAuthentication
		};
	}

	if (loginType === LOGIN_SYSTEM_TYPES.vectra) {
		return {
			loginInfo: `${t(
				'common_login_form_vectra_title'
			)} ${providerNameCapitalized}`,
			renderFirebaseAuth: hasFirebaseAuthentication
		};
	}
};

export const formatProviderTypeString = (provider) => {
	const providerName = provider.replace('.com', '');
	return providerName[0].toUpperCase() + providerName.slice(1);
};
